import { useStore } from 'zustand';
import { BusinessDistance, FinanceOption, TrimType } from '../../../types';
import { formatNumber } from '../../../utils/helpers';
import CarouselCardRow from './CarouselCardRow';
import { getStoreByKey } from './store/CarouselStore';
import { CarouselFieldsEnum } from './types/CarouselTypes';

interface Props {
  trim: TrimType;
  uniqId: string;
}

const CarouselBusinessRows = ({ trim, uniqId }: Props) => {
  const { options, selectedBusinessDistance, selectedFinanceOption } = useStore(
    getStoreByKey(uniqId),
  );

  const getPrice = () => {
    switch (selectedBusinessDistance) {
      case BusinessDistance.Two:
        return trim.business_leasing[0].s_6000_inkl_forsakring;
      case BusinessDistance.Three:
        return trim.business_leasing[0].s_9000_inkl_forsakring;
      case BusinessDistance.Four:
        return trim.business_leasing[0].s_12000_inkl_forsakring;
      default:
        return trim.business_leasing[0].s_4500_inkl_forsakring;
    }
  };

  const shoundRenderInPriceList = Boolean(
    !options &&
      (!selectedFinanceOption ||
        selectedFinanceOption === FinanceOption.BUSINESS),
  );
  return (
    <>
      {trim.business_leasing?.length ? (
        <>
          {shoundRenderInPriceList ||
          options?.fields?.includes(CarouselFieldsEnum.BUSINESS_LEASE) ? (
            <CarouselCardRow
              uniqId={uniqId}
              tooltip="Inkl. serviceavtal, försäkring, vinterhjul, 36 mån, ex.moms"
              label="Business Lease garanterat restvärde ⁵"
            >
              <p>Från {formatNumber(getPrice())} kr/mån*</p>
              <p>
                (Första förhöjd hyra{' '}
                {trim.business_leasing[0]?.andra_i_nedan_cell_1a_hyra_i}
                %)
              </p>
            </CarouselCardRow>
          ) : null}
        </>
      ) : null}
      {shoundRenderInPriceList ||
      [CarouselFieldsEnum.BENEFICIAL_VALUE, CarouselFieldsEnum.TAX].some(
        (field) => options?.fields?.includes(field),
      ) ? (
        <div className="grid grid-cols-2">
          {(shoundRenderInPriceList ||
            options?.fields?.includes(CarouselFieldsEnum.BENEFICIAL_VALUE)) &&
          trim.beneficial_value != null ? (
            <CarouselCardRow
              uniqId={uniqId}
              className={
                options?.fields?.includes(CarouselFieldsEnum.TAX) || !options
                  ? 'border-r border-slate-200 px-1'
                  : 'col-span-2'
              }
              tooltip="Baserat på en marginalskatt på 50%"
              label="Förmånsvärde fr. ⁷"
            >
              <p>{formatNumber(trim.beneficial_value)} kr/mån</p>
            </CarouselCardRow>
          ) : null}
          {(shoundRenderInPriceList ||
            options?.fields?.includes(CarouselFieldsEnum.TAX)) &&
          trim.vehicle_tax != null ? (
            <CarouselCardRow
              uniqId={uniqId}
              className={
                !options?.fields?.includes(
                  CarouselFieldsEnum.BENEFICIAL_VALUE,
                ) && options
                  ? 'col-span-2'
                  : 'px-1'
              }
              label="Fordonsskatt"
            >
              {formatNumber(trim.vehicle_tax)}
              kr/år
            </CarouselCardRow>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default CarouselBusinessRows;
